type SectionHeadingProps = {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ index, eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start"}`}>
      <div className="flex items-center gap-3">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-xs font-bold text-foreground-950">
          {index}
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-primary-700">
          {eyebrow}
        </span>
      </div>
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? "mx-auto" : ""}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}